














































































































































import { Vue, Component, Mixins } from "vue-property-decorator";
import fileSaver from "file-saver";

import MyList from "@/mixins/list";
import moment from "moment";
import Edit from "./stadiumvipexcel_edit.vue";

import Import from "./stadiumvipexcel_import.vue";

@Component({
  components: {
    Edit,
    Import
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "workorders/getVipExcel";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "提交人", dataIndex: "username" },
    { title: "场馆", dataIndex: "stadium_name" },
    { title: "文件", scopedSlots: { customRender: "excel" } },
    { title: "提交时间", dataIndex: "created_time" },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "处理时间", dataIndex: "updated_time" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  
// 操作搜索栏的展开和折叠
  isFlag = false;


  mounted() {
    this.loadData();
  }

  handleDownload(excel: string) {
    this.$confirm({
      title: "确认信息",
      content: "确认下载吗？",
      onOk: async () => {
        this.getSecretVideo(excel).then((url: string) => {
          fileSaver.saveAs(url, `excel${moment().format("YYYY-MM-DD HH:mm:ss")}.xlsx`);
        });
      }
    });
  }
}
